import axios from "axios";

const api = axios.create({
  baseURL: "https://prodv1.zeepconstruction.com",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000, // 30 saniye timeout
});

// Request interceptor (JWT token eklemek için ileride kullanılacak)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor (error handling için)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token geçersiz, login sayfasına yönlendir
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
